import { useMemo } from 'react';
import { transformReviewDocumentsToRestrictions, STATE_MAPPING } from '../helpers/review-documents-transformer';
import getRatificationStatusTranslation, { shouldShowRatificationMessage, isWithoutRatification } from '../helpers/ratification-status-translator';
import { enrichRestrictionsWithDocumentConfig } from '../helpers/restriction-document-config';

const useRatificationRestrictions = (invoice, type, baseRestrictions = null) => useMemo(() => {
  const ratificationRestriction = getRatificationStatusTranslation(
    invoice?.offer?.transferCondition,
    invoice?.isRatificated,
  );
  const reviewRestrictions = invoice?.reviewDocumentsManager
    ? transformReviewDocumentsToRestrictions(invoice.reviewDocumentsManager)
      .filter((res) => res.restrictionType === type)
    : [];

  const invoiceRestrictionsByType = (invoice?.restrictedBy || []).filter(
    (res) => res.restrictionType === type && res.restriction !== 'OTHER',
  );

  const pendingBaseRestrictions = baseRestrictions;
  const allBaseRestrictions = invoiceRestrictionsByType;
  const pendingReviewRestrictions = reviewRestrictions.filter(
    (restriction) => [STATE_MAPPING.PENDINGREVIEW,
      STATE_MAPPING.REJECTED].includes(restriction.status),
  );
  const pendingRestrictions = [...pendingBaseRestrictions, ...pendingReviewRestrictions];
  const allRestrictions = [...allBaseRestrictions, ...reviewRestrictions];
  if (shouldShowRatificationMessage(invoice, ratificationRestriction)) {
    pendingRestrictions.push(ratificationRestriction);
  }
  const transferCondition = invoice?.offer?.transferCondition;
  if (!isWithoutRatification(transferCondition, false) && ratificationRestriction != null) {
    allRestrictions.push(ratificationRestriction);
  }

  return {
    pendingRestrictions: enrichRestrictionsWithDocumentConfig(pendingRestrictions),
    allRestrictions: enrichRestrictionsWithDocumentConfig(allRestrictions),
  };
}, [invoice, type, baseRestrictions]);

export default useRatificationRestrictions;
